var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":_vm.eid}}),_c('y_upload_img_choose',{ref:"imgChoose",attrs:{"show-input":false,"full":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }